const configuredBaseUrl = (import.meta.env.VITE_AUTH_API_URL || '').trim()
const productionApiUrl = 'https://api.vetcrecon.io.vn'

// If the hosting provider omits the build-time API variable, do not let the
// SPA fallback serve index.html for authentication requests in production.
const baseUrl = (configuredBaseUrl ||
  (typeof window !== 'undefined' &&
  ['vetcrecon.io.vn', 'www.vetcrecon.io.vn'].includes(window.location.hostname)
    ? productionApiUrl
    : '')).replace(/\/$/, '')
export const apiUrl = (path: string) => `${baseUrl}${path}`
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message)
  }
}
export async function request<T>(
  path: string,
  method = 'GET',
  body?: unknown,
  options: { serverErrors?: boolean } = {},
): Promise<T> {
  const token = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith('XSRF-TOKEN='))
    ?.slice(11)
  const isFormData = typeof FormData !== 'undefined' && body instanceof FormData
  let response: Response
  try {
    response = await fetch(`${baseUrl}${path}`, {
      method,
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        ...(body !== undefined && !isFormData ? { 'Content-Type': 'application/json' } : {}),
        ...(token ? { 'X-XSRF-TOKEN': decodeURIComponent(token) } : {}),
      },
      ...(body !== undefined ? { body: isFormData ? body : JSON.stringify(body) } : {}),
    })
  } catch {
    throw new ApiError(0, 'Không thể kết nối máy chủ. Vui lòng kiểm tra kết nối và thử lại.')
  }
  if (!response.ok) {
    const data = (await readJson(response)) ?? {}
    if (response.status === 401) window.dispatchEvent(new Event('auth:unauthorized'))
    const fileError = data.errors?.file?.[0]
    const fileErrorText = typeof fileError === 'string' ? fileError.toLowerCase() : ''
    const message =
      response.status === 413 || /too large|max(?:imum)?/.test(fileErrorText)
        ? 'File vượt quá dung lượng cho phép (tối đa 50 MB).'
        : response.status === 422
          ? fileError
            ? 'File Excel không hợp lệ hoặc không đúng định dạng .xlsx.'
            : 'Dữ liệu gửi lên không hợp lệ. Vui lòng kiểm tra và thử lại.'
          : response.status >= 500
            ? 'Máy chủ gặp lỗi khi xử lý yêu cầu. Vui lòng thử lại sau.'
            : data.errors?.email?.[0] || data.message || 'Yêu cầu không hợp lệ.'
    const validationMessages = Object.values(data.errors || {})
      .flat()
      .filter((value): value is string => typeof value === 'string')
    const serverMessage = validationMessages.join('\n') || data.message || data.error?.message
    throw new ApiError(response.status, options.serverErrors && serverMessage ? serverMessage : message)
  }
  if (response.status === 204) return undefined as T

  const data = await readJson(response)
  if (data === null) {
    throw new ApiError(response.status, 'Máy chủ trả về dữ liệu không hợp lệ. Vui lòng kiểm tra cấu hình API.')
  }
  return data as T
}

async function readJson(response: Response): Promise<Record<string, any> | null> {
  const contentType = response.headers.get('content-type') || ''
  if (!contentType.toLowerCase().includes('application/json')) return null

  return response.json().catch(() => null)
}
